module.exports = __webpack_public_path__ + "media/images/map/map-marker-8f4b6d7e2d01a4399ed52f5fb92cf734.png";